<script setup lang="ts">
import Panel from 'primevue/panel'

import { RIcon } from '#atoms'

import type { RPanelProps } from './RPanel.types.ts'

defineProps<RPanelProps>()
</script>

<template>
  <Panel
    v-bind="{
      ...$props,
      ...$attrs,
    }"
    data-testid="r-panel"
    :pt="pt"
    :unstyled="false"
  >
    <template #toggleicon="data">
      <RIcon
        v-if="data.collapsed"
        icon="icon-[ph--caret-down]"
      />
      <RIcon
        v-else
        icon="icon-[ph--caret-up]"
      />
    </template>
    <template
      #header
      v-if="$slots.header"
    >
      <slot name="header"></slot>
    </template>
    <template
      #footer
      v-if="$slots.footer"
    >
      <slot name="footer"></slot>
    </template>
    <slot></slot>
  </Panel>
</template>

<style src="./RPanel.css"></style>
